import colors_red from '@components/Themes/colors_red.module.scss'
import baseClasses from '@components/Themes/layout.module.scss'
import red from '@mui/material/colors/red'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import AuthService from '@services/auth.service'
import Adminmodulescss from 'dist/css/Admin.module.scss'
import React, { FunctionComponent } from 'react'

const aptugotheme = createTheme({
  palette: {
    primary: red,
  },
})

import { Icon as YesIcon } from '@iconify/react'
import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import Container from '@mui/material/Container'
import TextField from '@mui/material/TextField'

const LoginPage: FunctionComponent = (props: any) => {
  const {
    history: navigation,
    match: { params },
  } = props
  const classes = baseClasses
  const [loginError, setloginError] = React.useState<any>(null)
  const [loginData, setloginData] = React.useState<any>({
    Email: '',
    Password: '',
    RememberMe: false,
  })
  const theme = { ...colors_red, ...baseClasses, ...Adminmodulescss }

  // Theme selection

  const handleLogin = () => {
    AuthService.login(loginData.Email, loginData.Password).then(
      (res) => {
        navigation.push('/admin')
      },
      (error) => {
        setloginError(error.response.data.message)
      }
    )
  }
  return (
    <React.Fragment>
      <ThemeProvider theme={aptugotheme}>
        <div className={theme.loginBody}>
          <Container className={theme.loginPage} maxWidth="md">
            <div data-title="div Image" className={theme.divImage}>
              <picture>
                <img src="/img/Home_topPageTitulo.svg" alt="/img/Home_topPageTitulo.svg" />
              </picture>
            </div>

            <div data-title="Register Area" className={theme.containerLogin}>
              <span className={theme.title}>Panel de administración</span>
            </div>

            <div data-title="Login Box" className={theme.loginBox}>
              {loginError && (
                <React.Fragment>
                  <Alert variant="standard" severity="error">
                    {loginError}
                  </Alert>
                </React.Fragment>
              )}

              <div data-title="div LoginDivInput" className={theme.loginDivInput}>
                <TextField
                  variant="outlined"
                  placeholder="Email Address"
                  margin="normal"
                  label="Email"
                  type="text"
                  value={loginData.Email}
                  onChange={(e) => {
                    setloginData({ ...loginData, Email: e.target.value })
                  }}
                />

                <div data-title="Account" className={theme.divIconInput}>
                  <YesIcon icon="mdi:account" style={{ fontSize: '20' }} />
                </div>
              </div>

              <div data-title="div LoginDivPassword" className={theme.loginDivInput}>
                <TextField
                  variant="outlined"
                  margin="normal"
                  label="Password"
                  type="password"
                  value={loginData.Password}
                  onChange={(e) => {
                    setloginData({ ...loginData, Password: e.target.value })
                  }}
                />

                <div data-title="Lock" className={theme.divIconInput}>
                  <YesIcon icon="mdi:lock" style={{ fontSize: '20' }} />
                </div>
              </div>

              <Button variant="contained" color="primary" onClickCapture={handleLogin} className={theme.buttonLogin}>
                <span className={theme.textButtonLogin}>Login</span>
              </Button>
            </div>
          </Container>
        </div>
      </ThemeProvider>
    </React.Fragment>
  )
}

export default LoginPage
